document.addEventListener("DOMContentLoaded", function () {
    
// Accordion field logic (for hiding empty ones)
  let visibleCount = 0;
  const dropdowns = document.querySelectorAll("[id^='accordion_']");

  dropdowns.forEach(dropdown => {
    const contentId = "accordion-content-" + dropdown.id;
    const content = document.getElementById(contentId);

    if (content && content.textContent.trim() === "") {
      dropdown.style.display = "none";
    } else {
      if (visibleCount >= 3) {
        dropdown.style.display = "none";
      } else {
        visibleCount++;
      }
    }
  });
});

// New logic: hide tabs if empty
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const tabIds = [
      "product-tab--one_column_ApmTzR",
      "product-tab--one_column_eYJfAx"
    ];

    tabIds.forEach(id => {
      const tabContent = document.getElementById(id);
      const tabTrigger = document.querySelector(`[aria-controls="${id}"]`);

      if (!tabContent || !tabTrigger) return;

      // Remove HTML tags and trim content
      const contentIsEmpty = tabContent.innerHTML.replace(/<[^>]*>/g, '').trim() === "";

      if (contentIsEmpty) {
        // Hide the tab content panel
        tabContent.style.display = "none";

        // Hide the tab button wrapper (li)
        const tabWrapper = tabTrigger.closest(".tab-buttons__button-wrapper");
        if (tabWrapper) {
          tabWrapper.style.display = "none";
        } else {
          tabTrigger.style.display = "none"; // fallback
        }
      }
    });
  }, 500); // Wait to ensure content has loaded
});
